import React from "react"

/**
 * Questions — src/Design/industries/industry-*.html, SECTION 6.
 * Native <details>/<summary> — every answer is real markup from first
 * render, not JS-revealed, and needs no accordion script at all. The first
 * question is open by default, matching the design files.
 */
const Questions = ({ eyebrow, heading, intro, linkHref, faqs = [] }) => (
  <section className="iquestions ip-block">
    <div className="iquestions__inner iquestions__split">
      <div className="iquestions__side">
        <p className="iquestions__eyebrow">{eyebrow}</p>
        <h2 className="iquestions__heading">{heading}</h2>
        <p className="iquestions__intro">{intro}</p>
        <a className="iquestions__link" href={linkHref}>
          Talk to us
        </a>
      </div>
      <div>
        {faqs.map((f, i) => (
          <details className="iquestions__item" key={f.q} open={i === 0 ? true : undefined}>
            <summary className="iquestions__q">{f.q}</summary>
            <p className="iquestions__a">{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
)

export default Questions
